module.exports = __webpack_public_path__ + "img/5D.24fd440c.png";